import { useState } from 'react'
import { LuPause, LuPlay } from 'react-icons/lu'
import Header from './components/Header'
import Home from './Home'
import CV from './components/CV'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'
import MakerDoodle from './components/MakerDoodle'
import './PersonalTouches.css'
import './Motion.css'

function App() {
    const [doodlesPaused, setDoodlesPaused] = useState(false)

    return (
        <Router>
            <div className="app" data-floating-paused={doodlesPaused}>
                <a className="skip-link" href="#main-content">
                    Skip to content
                </a>
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/cv" element={<CV />} />
                </Routes>
                <footer className="site-footer">
                    <div className="site-container site-footer__goodbye">
                        <div className="site-footer__identity">
                            <a
                                href="/#home"
                                className="site-footer__brand"
                                aria-label="Josephine Nguyen, back to home"
                            >
                                <img
                                    src={`${process.env.PUBLIC_URL}/logo192.png`}
                                    className="site-footer__logo"
                                    alt=""
                                    width="72"
                                    height="72"
                                />
                            </a>
                            <div>
                                <p className="handwritten site-footer__note">
                                    Thanks for wandering into my little corner
                                    of the internet!
                                </p>
                                <p className="site-footer__made">
                                    Built with big ideas, tiny details, and
                                    probably too many revisions ♡
                                </p>
                            </div>
                        </div>
                        <MakerDoodle
                            variant="thread"
                            className="site-footer__flourish"
                        />
                    </div>
                    <div className="site-container site-footer__inner">
                        <p className="site-footer__copyright">
                            © {new Date().getFullYear()}{' '}
                            <span>Josephine Nguyen</span>. All rights reserved.
                        </p>
                        <div className="site-footer__links">
                            <button
                                type="button"
                                className="motion-toggle"
                                aria-label={
                                    doodlesPaused
                                        ? 'Resume floating decorations'
                                        : 'Pause floating decorations'
                                }
                                onClick={() => setDoodlesPaused(!doodlesPaused)}
                            >
                                {doodlesPaused ? (
                                    <LuPlay aria-hidden="true" />
                                ) : (
                                    <LuPause aria-hidden="true" />
                                )}
                                {doodlesPaused
                                    ? 'Resume doodles'
                                    : 'Pause doodles'}
                            </button>
                            <a href="mailto:the.josephine.nguyen@gmail.com">
                                Email
                            </a>
                            <a
                                href="https://github.com/josephine828"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                GitHub
                            </a>
                            <a
                                href="https://www.linkedin.com/in/josephine-nguyen-software-engineer/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                LinkedIn
                            </a>
                        </div>
                    </div>
                </footer>
            </div>
            <Analytics />
        </Router>
    )
}

export default App
